var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 25C44 35.4934 35.4934 44 25 44C14.5066 44 6 35.4934 6 25C6 14.5066 14.5066 6 25 6C35.4934 6 44 14.5066 44 25ZM45 25C45 36.0457 36.0457 45 25 45C13.9543 45 5 36.0457 5 25C5 13.9543 13.9543 5 25 5C36.0457 5 45 13.9543 45 25ZM27 25C27 26.1046 26.1046 27 25 27C23.8954 27 23 26.1046 23 25C23 23.8954 23.8954 23 25 23C26.1046 23 27 23.8954 27 25ZM28 25C28 26.6569 26.6569 28 25 28C23.3431 28 22 26.6569 22 25C22 23.3431 23.3431 22 25 22C26.6569 22 28 23.3431 28 25ZM34 27C35.1046 27 36 26.1046 36 25C36 23.8954 35.1046 23 34 23C32.8954 23 32 23.8954 32 25C32 26.1046 32.8954 27 34 27ZM34 28C35.6569 28 37 26.6569 37 25C37 23.3431 35.6569 22 34 22C32.3431 22 31 23.3431 31 25C31 26.6569 32.3431 28 34 28ZM18 25C18 26.1046 17.1046 27 16 27C14.8954 27 14 26.1046 14 25C14 23.8954 14.8954 23 16 23C17.1046 23 18 23.8954 18 25ZM19 25C19 26.6569 17.6569 28 16 28C14.3431 28 13 26.6569 13 25C13 23.3431 14.3431 22 16 22C17.6569 22 19 23.3431 19 25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.1e03dde7b5809586c814d337762b2afc.svg";
export { ForwardRef as ReactComponent };